const LAST_SPACE = /[^\s|\u00A0]*$/
const SPACE = /\s|\u00A0/

const charAt = (string: string, index: number) => {
  const first = string.charCodeAt(index)
  let second
  if (first >= 0xd800 && first <= 0xdbff && string.length > index + 1) {
    second = string.charCodeAt(index + 1)
    if (second >= 0xdc00 && second <= 0xdfff) {
      return string.substring(index, index + 2)
    }
  }
  return string[index]
}

const slice = (string: string, start: number, end: number) => {
  if (!string) {
    return ''
  }
  let accumulator = ''
  let character
  let stringIndex = 0
  let unicodeIndex = 0

  while (stringIndex < string.length) {
    character = charAt(string, stringIndex)
    if (unicodeIndex >= start && unicodeIndex < end) {
      accumulator += character
    }
    stringIndex += character.length
    unicodeIndex += 1
  }
  return accumulator
}

export const countUnicodeLength = (string: string) => {
  if (!string) {
    return 0
  }

  let unicodeIndex = 0
  let stringIndex = 0

  while (stringIndex < string.length) {
    const character = charAt(string, stringIndex)
    stringIndex += character.length
    unicodeIndex += 1
  }

  return unicodeIndex
}

const sliceThreshold = (string: string, limit: number, threshold?: number) => {
  if (!string) {
    return ''
  }

  if (!threshold && string.indexOf(' ') < 0) {
    return slice(string, 0, limit)
  }

  let accumulator = ''
  let unicodeIndex = 0
  let stringIndex = 0

  while (unicodeIndex < limit) {
    const character = charAt(string, stringIndex)
    accumulator += character
    stringIndex += character.length
    unicodeIndex += 1
    if (stringIndex >= string.length) {
      break
    }
  }

  if (unicodeIndex < limit) {
    return accumulator
  }

  const lastSpaceIndex = accumulator.search(LAST_SPACE) - 1
  // cut with space
  if (lastSpaceIndex === accumulator.length - 1) {
    return accumulator
  }

  const remainStr = string.slice(lastSpaceIndex + 1)
  const nextSpaceIndex =
    remainStr.search(SPACE) > 0 ? remainStr.search(SPACE) + lastSpaceIndex + 1 : -1
  let lastword = string.substring(
    lastSpaceIndex + 1,
    nextSpaceIndex > 0 ? nextSpaceIndex : undefined
  )

  const usedLength = countUnicodeLength(accumulator.substring(0, lastSpaceIndex + 1))

  if (threshold) {
    const cutLength = limit - usedLength > threshold ? limit - usedLength : threshold

    lastword = slice(lastword, 0, cutLength)
  }

  return accumulator.substring(0, lastSpaceIndex + 1) + lastword
}

export const getShortString = (message: string, num: number, threshold?: number) => {
  if (!message) {
    return ''
  }

  return sliceThreshold(message, num, threshold)
}
